import React from "react";
import "./scss/switch.scss";

export default function Switch({ value = false, onChange }) {
  return (
    <div
      className={`switch ${value ? "active" : ""}`}
      onClick={() => onChange?.(!value)}
    >
      <div className="switch__thumb" />
    </div>
  );
}
